import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { Track } from '../../api.js';
import type { Appearance } from './types.js';
import { statusForTrackState } from './statusMap.js';

export default function RequestsCard({
  tracks,
  appearance,
  onOpen,
}: {
  tracks: Track[];
  appearance: Appearance;
  onOpen: (id: string) => void;
}) {
  const [tab, setTab] = useState<'internal' | 'community'>('internal');
  const showTabs = appearance.communityPreview;
  const activeTab = showTabs ? tab : 'internal';

  const recent = [...tracks]
    .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
    .slice(0, 10);

  return (
    <div className="conductor-card">
      <div className="conductor-card-header">
        <span className="conductor-card-title">Requests</span>
        {showTabs && (
          <div className="requests-tabs">
            <button
              type="button"
              className={`requests-tab${activeTab === 'internal' ? ' requests-tab-active' : ''}`}
              onClick={() => setTab('internal')}
            >
              Internal ({recent.length})
            </button>
            <button
              type="button"
              className={`requests-tab${activeTab === 'community' ? ' requests-tab-active' : ''}`}
              onClick={() => setTab('community')}
            >
              Community (0)
            </button>
          </div>
        )}
      </div>

      {activeTab === 'internal' ? (
        <>
          <div className="requests-list">
            {recent.length === 0 && <div className="empty">No requests yet.</div>}
            {recent.map((track) => {
              const { status, label } = statusForTrackState(track.state);
              return (
                <div
                  className="request-row"
                  key={track.id}
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onOpen(track.id)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') onOpen(track.id);
                  }}
                >
                  <div className="request-row-main">
                    <div className="request-row-title">{track.title}</div>
                    <div className="request-row-chips">
                      <span className="build-status-chip" data-status={status}>
                        {label}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="actions" style={{ marginTop: 14 }}>
            <Link
              to="/drop-idea"
              className="btn-conductor"
              style={{ textDecoration: 'none', display: 'inline-block' }}
            >
              + Drop idea
            </Link>
          </div>
        </>
      ) : (
        <>
          <p className="requests-explainer">
            Community requests need approval before they enter the build queue.
          </p>
          <div className="requests-list">
            <div className="empty">No community requests yet.</div>
          </div>
        </>
      )}
    </div>
  );
}
